import React from 'react';
import Style from './index.less';
import { HistoryEventType, IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';

export interface IHistoryLoadingMaskProps {
    historyManager: IHistoryManager;
}

interface IHistoryLoadingMaskStates {
    showHistoryMask: boolean;
}

export class HistoryLoadingMask extends React.Component<IHistoryLoadingMaskProps, IHistoryLoadingMaskStates> {
    public constructor(props: IHistoryLoadingMaskProps) {
        super(props);
        this.state = {
            showHistoryMask: false,
        };
        this.props.historyManager.on(HistoryEventType.FETCH_BEGIN, () => {
            this.setState({ showHistoryMask: true });
        });
        this.props.historyManager.on(HistoryEventType.FETCH_END, () => {
            this.setState({ showHistoryMask: false });
        });
    }

    public render() {
        const { showHistoryMask } = this.state;
        return showHistoryMask ? <div className={Style['history-mask']}><div className={Style['history-mask-loading']} /></div> : null;
    }
}
